import { Injectable } from "@angular/core";
import { Headers, RequestOptions, URLSearchParams, RequestMethod } from "@angular/http";
import { CONFIGURATION } from "../../app.constants";
import { Token } from "../../models/token";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "./httpData.service";
import { CurrentUserService } from "./currentUser.service";
import { Router, CanActivate } from "@angular/router";

@Injectable()
export class UserAuthenticationService implements CanActivate {

    constructor(private http: HttpDataService,
        private currentUserService: CurrentUserService,
        private router: Router) { }

    get isAuthenticated(): boolean {
        if (!this.currentUserService.token) {
            return false;
        }
        return true;
    }

    public Login(username: string, password: string): Observable<Token> {
        let params = new URLSearchParams();
        if (username) params.set("username", username);
        if (password) params.set("password", password);
        params.set("externalOrganisationId", "''");
        params.set("grant_type", "password");
        let options = new RequestOptions({
            method: RequestMethod.Post,
            headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
            body: params
        });

        return Observable.create((observer) => {
            this.http.request(CONFIGURATION.baseUrls.server + "token", options)
                .map(response => <Token>response.json())
                .subscribe((tokenData) => {
                    this.currentUserService.token = tokenData;
                    observer.next(tokenData);
                }, (error) => observer.error(error),
                () => observer.complete());

        });
    }


    public LoginSSO(username: string, password: string): Observable<Token> {
        let params = new URLSearchParams();
        if (username) params.set("username", username);
        if (password) params.set("password", password);
        params.set("externalOrganisationId", "''");
        params.set("authProviderId",CONFIGURATION.baseUrls.authProviderId);
        params.set("grant_type", "password");
        let options = new RequestOptions({
            method: RequestMethod.Post,
            headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
            body: params
        });

        return Observable.create((observer) => {
            this.http.request(CONFIGURATION.baseUrls.server + "token", options)
                .map(response => <Token>response.json())
                .subscribe((tokenData) => {
                    this.currentUserService.token = tokenData;
                    
                    observer.next(tokenData);
                }, (error) => observer.error(error),
                () => observer.complete());

        });
    }

    public ResetAccessToken(externalOrganisationId: string): Observable<Token> {
        if (!this.isAuthenticated) return null;
        let body = `grant_type=refresh_token&refresh_token=${this.currentUserService.token.refresh_token}&externalOrganisationId=${externalOrganisationId}`;
        let options = new RequestOptions({
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded" })
            });

        return Observable.create((observer) => {
            this.http.post(CONFIGURATION.baseUrls.server + "token", body, options)
                .map(response => <Token>response.json())
                .subscribe((tokenData) => {
                    this.currentUserService.token = tokenData;
                    observer.next(tokenData);
                }, (error) => observer.error(error),
                () => observer.complete());

        });
    }

    public Logout() {
        this.currentUserService.token = null;
        this.currentUserService.userInfo = null;
        // window.location.href =  CONFIGURATION.baseUrls.cloudUi + "logout";
        this.router.navigate(["/logout"]);
    }

    public canActivate() {
        return this.isAuthenticated;
    }
}




// WEBPACK FOOTER //
// ./src/app/services/shared/userAuthentication.service.ts